/**
 * cart-recommendations.js
 * Phase 2: Swap upsell - add new item first, then remove old. Never remove first.
 * Phase 3: Add cross-sell - POST to cart/add.js, show checkmark, dispatch cart:refresh.
 */
(function () {
  "use strict";

  var CHECKMARK_SVG =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

  async function addToCart(variantId) {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || "Add failed");
      }

      document.dispatchEvent(new CustomEvent("cart:refresh"));
      return true;
    } catch (err) {
      console.error("Cart add failed:", err);
      return false;
    }
  }

  async function swapCartItem(currentKey, newVariantId) {
    try {
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: newVariantId, quantity: 1 }),
      });

      if (!addRes.ok) {
        const err = await addRes.json();
        throw new Error(err.description || "Add failed");
      }

      const updateRes = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [currentKey]: 0 } }),
      });

      if (!updateRes.ok) {
        const err = await updateRes.json();
        throw new Error(err.description || "Update failed");
      }

      document.dispatchEvent(new CustomEvent("cart:refresh"));
      return true;
    } catch (err) {
      console.error("Cart swap failed:", err);
      return false;
    }
  }

  document.addEventListener("click", function (e) {
    const swapBtn = e.target.closest("[data-swap-trigger]");
    if (!swapBtn) return;

    const card = swapBtn.closest("[data-upsell]");
    if (!card) return;

    const currentKey = card.dataset.currentKey;
    const newId = card.dataset.newId;
    if (!currentKey || !newId) return;

    swapBtn.disabled = true;
    swapCartItem(currentKey, newId).then(function (ok) {
      if (!ok) swapBtn.disabled = false;
    });
  });

  document.addEventListener("click", function (e) {
    const addBtn = e.target.closest("[data-add-trigger]");
    if (!addBtn) return;

    const variantId = addBtn.dataset.variantId;
    if (!variantId || addBtn.disabled) return;

    addBtn.disabled = true;
    addToCart(variantId).then(function (ok) {
      if (ok) {
        addBtn.classList.add("cart-reco-card__add-btn--added");
        addBtn.setAttribute("aria-label", addBtn.getAttribute("data-added-label") || "Added to cart");
        addBtn.innerHTML = CHECKMARK_SVG;
      } else {
        addBtn.disabled = false;
      }
    });
  });
})();
